<template>
  <BasicSection appearance="horizontal">
    <div class="ratings-page-search-panel">
      <slot />
    </div>
  </BasicSection>
</template>

<script>
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  
  export default {
    name: 'RatingsPageSearchPanel',
    components: { BasicSection },
  }
</script>